import React, { Component } from "react";
import PageHeaderWrapper from "../../../../components/PageHeaderWrapper";
import { TableComp } from "sz-react-utils";
import moment from "moment";
import _ from "lodash";
import ListFollowUps from "../../../../components/_utils/listFollowUp";
import { RightsWrapper } from "../../../../components/_utils/utils";
import {
  Avatar,
  Button,
  Card,
  Col,
  Checkbox,
  notification,
  Popconfirm,
  Drawer,
  Table,
  Tooltip,
  Select,
  Input,
  DatePicker
} from "antd";
import Request from "../../../../request";
import LatestFollowUp from "../../../../components/_utils/latestFollowup";
import { connect } from "react-redux";
import styles from "./styles.less";
import common from "../../../common.less";
import Settings from "../../../../components/_utils/settings";
import rightAuth from "../../../../components/_utils/userRights";
import lodash from 'lodash'

import { hideLoader, showLoader } from '../../../../modules/actions';

import SMS from '../../../../components/communication/sms'
import WhatsAPPSMS from '../../../../components/communication/WhatsAppSms'
import EmailDrawer from '../../../../components/communication/emailDrawer'
let dateFormat = localStorage.getItem('company-details') ? JSON.parse(localStorage.getItem('company-details')).dateFormat : 'DD.MM.YYYY';
let studentObj = {};
let userCheckBox = {}
let counsellingData = {}
const activeUser = localStorage.getItem('user') ? JSON.parse(localStorage.getItem('user')) : {};
const { Option } = Select

const { RangePicker } = DatePicker

class CollapseViewBox extends Component {
  state = {
    cp: false,
  };

  render() {
    const { cp } = this.state;
    const clondData = this.props.children;
    return (
      <React.Fragment>
        <div>
          <div
            className={
              cp ? styles.questioncollapse : styles.questioncollapsenot
            }
          >
            {clondData && clondData.course &&
              clondData.course
                .slice(0, cp ? clondData.course.length : 1)
                .map((item) => {
                  return (
                    <ul className={styles.ul}>
                      <li>
                        <b>{item.courseName}{item.campusName && `(${item.campusName})`}</b>
                      </li>
                      <li>{item.universityInstitutionName}</li>
                      <li>
                        <small>
                          {" "}
                          {item.univData &&
                            item.univData.universityCityId &&
                            `${item.univData.universityCityId.cityName} ,`}
                          {item.univData &&
                            item.univData.universityStateId &&
                            `${item.univData.universityStateId.stateName} ,`}
                          {item.univData &&
                            item.univData.universityCountryId &&
                            `${item.univData.universityCountryId.countryName}`}
                        </small>
                      </li>
                    </ul>
                  );
                })}
          </div>
          {clondData && clondData.course && clondData.course.length > 1 ? (
            <button
              style={{ color: "red" }}
              onClick={() => {
                this.setState({
                  cp: !cp,
                });
              }}
            >
              {cp ? <p>View Less - </p> : <p>View More + </p>}
            </button>
          ) : null}
        </div>
      </React.Fragment>
    );
  }
}

class DeadCounsellingDesk extends Component {
  state = {
    count: 0,
    followDuesCount: 0,
    showFollowUp: false,
    studentId: null,
    studentSearchId: '',
    branchId: "",
    counsellorId: "",
    exdCounsellorId: [],
    allBranches: [],
    allCounsellor: [],
    counsellors: [],
    ratingArr: [],
    subRatingArr: [],
    modeArr: [],
    deskColor: null,
    time: {
      key: "createdByUser.time",
      from: null,
      to: null,
    },
    courseList: [],
    selectStudentId: "",
    ratingId: "",
    subRatingId: "",
    courseDrawer: false,
    isFollowUpOverdue: false,
    showSMS: false,
    showWhatsAppSms: false,
    showEmail: false,
    userCheckBox: {},
    exportParams: {}
  };
  reload = () => {
    this.table.current.reload();
  };
  showSMS = () => {
    let userArr = lodash.filter(this.state.userCheckBox, (item) => {
      return item.isChecked
    })
    if (userArr && userArr.length) {
      counsellingData = {
        usersData: userArr
      }
      this.setState({ showSMS: true })
    } else {
      notification.error({
        message: 'Please select atleast 1 user.'
      })
    }
  }
  closeSMS = () => {
    this.setState({ showSMS: false })
  }
  showWhatsAppSms = () => {
    let userArr = lodash.filter(this.state.userCheckBox, (item) => {
      return (item.isChecked === true ? item : false);
    })

    if (userArr && userArr.length) {
      counsellingData = {
        usersData: userArr
      }
      this.setState({ showWhatsAppSms: true })
    } else {
      notification.error({
        message: 'Please select atleast 1 user.'
      })
    }
  }
  closeWhatsSMS = () => {
    this.setState({ showWhatsAppSms: false })
  }
  closeEmail = () => {
    this.setState({ showEmail: false })
  }
  showEmail = () => {
    let userArr = lodash.filter(this.state.userCheckBox, (item) => {
      return item.isChecked
    })
    if (userArr && userArr.length) {
      counsellingData = {
        usersData: userArr
      }
      this.setState({ showEmail: true })
    } else {
      notification.error({
        message: 'Please select atleast 1 user.'
      })
    }
  }
  selectUser = (item, studentId) => {
    let cloneUserCheckBox = lodash.clone(this.state.userCheckBox)
    if (cloneUserCheckBox[studentId] === undefined) {
      cloneUserCheckBox[studentId] = [];
    }
    cloneUserCheckBox[studentId].isChecked = !cloneUserCheckBox[studentId].isChecked
    this.setState({ userCheckBox: cloneUserCheckBox })
  }
  selectAllUserFxn = () => {
    let cloneUserCheckBox = lodash.clone(this.state.userCheckBox)
    lodash.each(cloneUserCheckBox, (item) => {
      item.isChecked = true
    })
    this.setState({ userCheckBox: cloneUserCheckBox })
  }
  unselectAllUserFxn = () => {
    let cloneUserCheckBox = lodash.clone(this.state.userCheckBox)
    lodash.each(cloneUserCheckBox, (item) => {
      item.isChecked = false
    })
    this.setState({ userCheckBox: cloneUserCheckBox })
  }

  exportExcel = async () => {
    const { exportParams, count } = this.state
    exportParams.results = count
    exportParams.count = count
    let x = await Request.exportCounsellingDeskToExcel({ ...exportParams })
    // let x = await Request.exportUsersToExcel({
    //      regExFilters: ['name'
    //     ]
    // })
    if (!x.error) {
      window.open(x.url)
    }
  }

  apiRequest = (params) => {
    return new Promise(async (resolve) => {
      if (!params.sortField) {
        params.sortField = "id";
        params.sortOrder = "descend";
      }
      if (this.state.counsellorId) {
        params.counsellorId = this.state.counsellorId;
      }
      if (this.state.exdCounsellorId) {
        params.exdCounsellorId = this.state.exdCounsellorId;
      }
      if (this.state.ratingId) {
        params["counsellingDesk.rating"] = this.state.ratingId;
      }
      if (this.state.subRatingId) {
        params["counsellingDesk.subRating"] = this.state.subRatingId;
      }
      if (this.state.studentSearchId) {
        params.studentSearchId = this.state.studentSearchId
      } else {
        params.studentSearchId = '';
      }

      let searchParams = new URLSearchParams(this.props.search);
      let ratingId = searchParams.get("ratingId");
      let subRatingId = searchParams.get("subRatingId");
      if (ratingId) {
        params["counsellingDesk.rating"] = ratingId;
      }
      if (subRatingId) {
        params["counsellingDesk.subRating"] = subRatingId;
      }

      if (this.state.branchId) {
        params.studentBranchId = this.state.branchId;
      }
      if (params.dateOfBirth && params.dateOfBirth.length > 0) {
        var splitDate = params.dateOfBirth[0].split("-");
        const monthNames = [
          "January",
          "February",
          "March",
          "April",
          "May",
          "June",
          "July",
          "August",
          "September",
          "October",
          "November",
          "December",
        ];
        var monthName = monthNames[splitDate[1] - 1];

        params.dateOfBirth =
          splitDate[0] + "-" + monthName + "-" + splitDate[2];

        const stringToDate = new Date(params.dateOfBirth);
        params.dateOfBirth = {
          $gte: stringToDate.setHours(0, 0, 0),
          $lt: stringToDate.setHours(23, 59, 59),
        };
      } else {
        delete params.dateOfBirth;
      }

      params.atLevel = ["Dead Counselling Desk"];

      if (this.state.isFollowUpOverdue) {
        params.isFollowUpOverdue = this.state.isFollowUpOverdue;
      }
      let data = await Request.loadCounselling({
        ...params,
        regExFilters: [
          "studentName",
          "location",
          "email",
          "mobile",
          "updatedByUser.name",
          "createdByUser.name",
        ],
        dateFilter: this.state.time,
      });
      delete data.error;
      delete data.type;
      lodash.each(data.data, (item) => {
        if (!userCheckBox[item._id]) {
          userCheckBox[item._id] = {
            _id: item._id,
            emailId: item.emailId,
            mobile: item.mobile,
            studentName: item.studentName,
            isChecked: false
          }
        }
      })

      this.setState({ count: data.total, followDuesCount: data.followUpsDuesCount, allBranches: data.allBranches, userCheckBox: userCheckBox, exportParams: params });
      resolve(data);
    });
  };

  closeFollowUp = () => {
    this.setState({
      showFollowUp: false,
    }, () => {
      this.table.current.reload()
    });
  };

  openFollowUps = (record) => {
    studentObj = {
      arr: record.followUp,
      name: record.studentName,
      rating: record.counsellingDesk.rating,
      subRating: record.counsellingDesk.subRating,
      _id: record._id,
    };
    this.setState({ showFollowUp: true });
  };

  followUpExtendedDate = (followUp) => {
    if (followUp && followUp.followUpDate) {
      return moment(moment(new Date()).format('YYYY-MM-DD[T00:00:00.000Z]')).isAfter(followUp.followUpDate);
    }
  }

  getAllSource = async () => {
    let response = await Request.getSourceDetails({
      results: 1000,
      count: 1000
    })
    let sourceObject = [];
    response.data && response.data.map((source) => {
      sourceObject.push(source.sourceName)
    })
    this.setState({ modeArr: sourceObject })
  }

  renderStatus = (val) => {
    if (val === "Super Hot") {
      return <div className={styles.SuperHot}>{val.toUpperCase()}</div>;
    }
    if (val === "Fit2Apply") {
      return <div className={styles.Fit2Apply}>{val.toUpperCase()}</div>;
    }

    if (val === "Neutral") {
      return <div className={styles.LukeWarm}>{val.toUpperCase()}</div>;
    }

    if (val === "Potential") {
      return <div className={styles.Potential}>{val.toUpperCase()}</div>;
    }

    if (val === "Dead") {
      return <div className={styles.dead}>{val.toUpperCase()}</div>;
    }

    if (val === "Cold") {
      return <div className={styles.Cold}>{val.toUpperCase()}</div>;
    }
    if (val === "Active") {
      return <div className={styles.Cold}>{val.toUpperCase()}</div>;
    }
  };
  chooseRangerPicker = (date, dateString) => {
    this.setState(
      {
        time: {
          key: "createdByUser.time",
          from: date[0],
          to: date[1],
        },
      },
      () => {
        this.reload();
      }
    );
    if (date[0] === undefined) {
      setTimeout(() => {
        this.reload();
      }, 500);
    }
  };

  onOk = value => {
    this.reload()
  }

  async componentWillMount() {
    let searchParams = new URLSearchParams(this.props.search);
    let createdByUserDate = searchParams.get("dateFilter");
    if (createdByUserDate) {
      this.setState(
        {
          time: {
            key: "createdByUser.time",
            from: moment(createdByUserDate, "DD-MM-YYYY")
              .startOf("day")
              .toDate(),
            to: moment(createdByUserDate, "DD-MM-YYYY")
              .endOf("day")
              .toDate(),
          },
        },
        () => {
          console.log("adsffs", this.state.time);
        }
      );
    }
    this.setState({ deskColor: Settings.deskColor("Front Desk") });


    let ratingId = searchParams.get("ratingId");
    let subRatingId = searchParams.get("subRatingId");
    if (ratingId || subRatingId) {
      setTimeout(() => {
        this.table.current.reload()
      }, 1000);
    }
  }

  getAllRatings = async () => {
    let response = await Request.getRatingsDetails({
      results: 1000,
      count: 1000
    })
    this.setState({ ratingArr: response.data })
  }

  getAllSubRatings = async (parentRatingId) => {
    let response = await Request.getSubRatingsDetails({
      results: 1000,
      count: 1000,
      parentRatingId: parentRatingId
    })
    this.setState({ subRatingArr: response.data })
  }

  constructor(props) {
    super(props);
    this.loadCountries();
    this.table = React.createRef();
    this.followUpsCallback = this.followUpsCallback.bind(this);
    Request.getCounsellorsUsers()
      .then(resp => {
        if (resp) {
          let temp = [{ display: '---Show All---', id: '' }];
          resp.data = resp.data.reduce((el, vv) => {
            vv.display = vv.name
            vv.id = vv._id
            temp.push(vv)
            return temp
          }, []);
          this.setState({ counsellors: resp.data })
        }
      })
      .catch(err => {
      })
  }

  async loadCountries() {
    let { data: countriesList } = await Request.getCountriesWithoutAuth({
      results: 10000,
      businessId: activeUser && activeUser.businessId
    })
    let countryList = []
    _.each(countriesList, (item) => {
      countryList.push({ value: item.countryName, text: item.countryName })
    })
    this.setState({ allcountries: countryList })
  }

  async componentDidMount() {
    await this.getAllRatings();
    await this.getAllSource();
    let { data } = await Request.loadDeskUser({
      results: 10000,
      isCounsellor: true,
      active: true
    });
    this.setState({
      allCounsellor: data,
      loading: false,
    });
  }

  async getStudentCourse(inquiryId) {
    this.setState({ loading: true });
    let { doc } = await Request.getInquiry(inquiryId);
    this.setState({ loading: false });
    if (doc) {
      let counsellingDesk = doc.counsellingDesk;
      this.setState({
        courseList: counsellingDesk.course,
        courseDrawer: true,
      });
    }
  }

  followUpsCallback(isFollowUpOverdue) {
    this.setState({
      isFollowUpOverdue: isFollowUpOverdue,
    }, () => {
      this.table.current.reload()
    });
  }

  handleStudentMoveStudy = async (data) => {
    let response = await Request.moveStudentToStudy(data);
    if (!response.error) {
      this.table.current.reload()
      notification.success({
        message: response.message,
      });
    } else {
      notification.error({
        message: response.message,
      });
    }
  }


  render() {
    const { dispatch } = this.props;
    const {
      allBranches = [],
      allCounsellor = [],
      deskColor,
      ratingArr,
      modeArr,
      allcountries = [],
      counsellors,
      subRatingArr
    } = this.state;

    const columns = [
      {
        title: "Action",
        key: "operation",
        dataindex: "operation",
        fixed: true,
        width: 140,
        render: (text, record) => (
          <React.Fragment>
            <Tooltip title="Select">
              <span className={styles.userSelectCheckbox}>
                <Checkbox
                  checked={userCheckBox[record._id] ? userCheckBox[record._id].isChecked : false}
                  onChange={y => {
                    this.selectUser(y, record._id)
                  }}>
                </Checkbox>
              </span>
            </Tooltip>&nbsp;
            <Tooltip title="FollowUps">
              <Button
                className={styles.btn}
                size={"small"}
                shape="circle"
                onClick={() => this.openFollowUps(record)}
                icon="calendar"
              />
            </Tooltip>&nbsp;
            <Tooltip title="Click To Edit Details">
              <Button
                className={styles.btn}
                shape="circle"
                size={"small"}
                href={`/desk/update-counselling?id=${record._id}`}
                icon="edit"
              />
            </Tooltip>&nbsp;
            <Tooltip title="Click To View Courses">
              <Button
                className={styles.btn}
                shape="circle"
                size={"small"}
                onClick={() => {
                  this.getStudentCourse(record._id);
                }}
                icon="eye"
              />
            </Tooltip>
          </React.Fragment>
        ),
      },
      {
        title: "VID",
        key: "id",
        dataIndex: "id",
        sorter: true,
        fixed: true,
        searchTextName: "id",
        filterRegex: true,
      },
      {
        title: "Student Name",
        key: "studentName",
        dataIndex: "studentName",
        sorter: true,
        fixed: true,
        searchTextName: "studentName",
        filterRegex: true,
        render: (text, record) => (
          <React.Fragment>
            <div
              className={
                this.followUpExtendedDate(record.followUp ? record.followUp : '') ? styles.followUpExtendedDate : ''
              }
            >
              <Tooltip title="Click To View Student Details">
                <a
                  className={styles.btn}
                  target={"_blank"}
                  href={`/inquiry/studentProfileDetails?id=${record._id}`}
                >
                  {text}
                </a>
              </Tooltip>
            </div>

          </React.Fragment>
        ),
      },
      {
        title: "Date of Birth ",
        width: 100,
        key: "dateOfBirth",
        dataIndex: "dateOfBirth",
        searchTextName: `${dateFormat}`,
        render: (val, record) => {
          return (
            <div>
              {record.dateOfBirth
                ? moment(record.dateOfBirth).format(dateFormat)
                : ""}
            </div>
          );
        },
      },
      {
        title: 'Passport No',
        key: 'passportNo',
        searchTextName: 'passportNo',
        filterRegex: true,
        width: 150,
        dataIndex: 'visaDesk.passportNo'
      },
      {
        title: "Mode",
        key: "mode",
        dataIndex: "mode",
        filters: modeArr && modeArr.map((x) => ({ value: x, text: x }))
      },
      {
        title: "Counsellor",
        key: "counsellorId",
        filters: allCounsellor.map((x) => ({ value: x._id, text: x.name })),
        render: (text, record) => {
          return (
            <div>{record.counsellorId ? record.counsellorId.name : ""}</div>
          );
        },
      },
      {
        title: "Rating",
        width: 180,
        key: "rating",
        dataIndex: "counsellingDesk.rating",
        filters: ratingArr && ratingArr.map((x) => ({ value: x._id, text: x.ratingName })),
        render: (val, record) => {
          let ratingObject = record.counsellingDesk && record.counsellingDesk.ratingObject ? record.counsellingDesk.ratingObject : null;
          let subRatingObject = record.counsellingDesk && record.counsellingDesk.subRatingObject ? record.counsellingDesk.subRatingObject : null;
          return (
            <div>
              {
                ratingObject ?
                  <div className="antd-pro-containers-desk-counselling-all-styles-rating" style={{ background: ratingObject.ratingColor, borderColor: ratingObject.ratingColor }}>{ratingObject.ratingName} {subRatingObject && subRatingObject.ratingName ? ('/ ' + subRatingObject.ratingName) : ''}</div>
                  :
                  this.renderStatus(val)
              }
            </div>
          )
        },
      },
      {
        title: "Preference",
        key: "preference",
        filters: allcountries,
        render: (val, row) => {
          return row.totalPreference ? (
            <ul className={common.ul}>
              {row.totalPreference.map((val, inde) => {
                return <li key={inde}>{val ? val.country : ""}</li>;
              })}
            </ul>
          ) : null;
        },
      },
      {
        title: "Course/University",
        key: "counsellingDesk.course",
        width: 280,
        dataIndex: "course",
        render: (text, record) => {
          return <CollapseViewBox>{record.counsellingDesk}</CollapseViewBox>;
        },
      },
      {
        title: "Test Score",
        key: "ieltsOverallScore",
        dataIndex: "ieltsOverallScore",
        searchTextName: "ieltsOverallScore",
        filterRegex: true,
        width: 180,
        render: (text, record) => {
          return (
            <div style={{ fontSize: "12px" }}>
              <div style={{ paddingBottom: "4px" }}>
                {" "}
                {record.testType && text
                  ? `${record.testType} OverAll : ${text}`
                  : null}
              </div>
              <div style={{ paddingBottom: "4px" }}>
                {record && record.profile && record.profile.reading
                  ? `Reading : ${record.profile.reading}`
                  : null}{" "}
                {record && record.profile && record.profile.writing
                  ? `Writing : ${record.profile.writing}`
                  : null}{" "}
              </div>
              <div>
                {record && record.profile && record.profile.listening
                  ? `Listening : ${record.profile.listening}`
                  : null}{" "}
                {record && record.profile && record.profile.speaking
                  ? `Speaking : ${record.profile.speaking}`
                  : null}
              </div>
            </div>
          );
        },
      },
      {
        title: "Follow Up",
        key: "followUp",
        width: 200,
        searchTextName: "followUp",
        filterRegex: true,
        dataIndex: "followUp",
        render: (text, record) => {
          return <LatestFollowUp info={text} />;
        },
      },
      {
        title: "MOB/WAP/Mail",
        key: "mobwap",
        dataIndex: "mobwap",
        searchTextName: "MOB/WAP/Mail",
        render: (val, record) => {
          return (
            <div>
              <div>
                <span>
                  {record.mobile && record.mobile.length >= 10 && rightAuth.checkRights("ShowClickToCall.view") ? (
                    <Tooltip title="Start Call">
                      <Button
                        className='ant-btn ant-btn-primary'
                        onClick={(e) => {
                          dispatch(showLoader())
                          Request.callInitiate({
                            mobile: record.mobile,

                          }).then(({ data, error, message }) => {
                            dispatch(hideLoader())
                            if (!error) {
                              notification.success({
                                message: message
                              })
                            } else {
                              notification.error({
                                message: message
                              })
                            }
                          })
                        }}
                      >
                        Click To Call
                      </Button>
                    </Tooltip>
                  ) : (
                    record.mobile
                  )}
                </span>
              </div>
              <div>
                {record.watsupp && record.watsupp.length === 10 ? (
                  <Tooltip title="Share on Whatsapp">
                    <a
                      target={"_blank"}
                      style={{ textDecoration: "underline" }}
                      href={`http://api.whatsapp.com/send?phone=91${record.watsupp
                        }&text=&source=&data=`}
                    >
                      {record.watsupp}
                    </a>
                  </Tooltip>
                ) : (
                  record.watsupp
                )}
              </div>
              <div>
                <span>{record.emailId}</span>
              </div>
            </div>
          );
        },
      },
      {
        title: "Source",
        key: "location",
        dataIndex: "location",
        searchTextName: "location",
        filterRegex: true,
      },
      {
        title: "Branch",
        key: "studentBranchId",
        filters: allBranches,
        render: (text, record) => {
          return (
            <div>
              {record.studentBranchId ? record.studentBranchId.branchName : ""}
            </div>
          );
        },
      },
      {
        title: "Last Updated By",
        width: 150,
        key: "updatedByUser",
        searchTextName: "updatedByUser",
        filterRegex: true,
        dataIndex: "updatedByUser",
        render: (text, record) => {
          return (
            <div>
              <div className={common.user}>{text ? text.name : ""}</div>
              <small>{text ? moment(text.time).format("lll") : ""}</small>
            </div>
          );
        },
      },


      // {
      //   title: "Photo",
      //   key: "profilePic",
      //   width: 60,
      //   dataIndex: "profilePic",
      //   render: (val) => {
      //     return <Avatar src={val} />;
      //   },
      // },


    ];

    const courseColumns = [
      {
        title: "Course Name",
        dataIndex: "courseName",
        key: "courseName",
      },
      {
        title: "University",
        dataIndex: "universityInstitutionName",
        key: "universityInstitutionName",
      },
      {
        title: "PathWay",
        dataIndex: "pathwayName",
        key: "pathwayName",
      },
      {
        title: "Fees/Duration",
        width: 150,
        key: "tutionFee",
        dataIndex: "tutionFee",
        render: (val, record) => {
          return (
            <div>
              <span>{record.tutionFee} /</span>
              <span>{record.courseDuration}</span>
            </div>
          );
        },
      },
    ];

    return (
      <PageHeaderWrapper
        deskColor={deskColor}
        title={` Dead Counselling Desk : ${this.state.count} `}
        subTitle={`Follow Up Overdue : ${this.state.followDuesCount}`}
        followUpsCallback={this.followUpsCallback}
      >
        {this.state.showFollowUp ? (
          <ListFollowUps studentObj={studentObj} onClose={this.closeFollowUp} />
        ) : null}
        {this.state.showWhatsAppSms ? (
          <WhatsAPPSMS counsellingData={counsellingData} onClose={this.closeWhatsSMS} />
        ) : null}

        {this.state.showSMS ? (
          <SMS counsellingData={counsellingData} onClose={this.closeSMS} />
        ) : null}

        {this.state.showEmail ? (
          <EmailDrawer counsellingData={counsellingData} onClose={this.closeEmail} />
        ) : null}
        <Card style={{ marginBottom: 10 }}>
          <div>
            <Col span={8}>
              <label>Date of Lead Addition</label>
              <RangePicker
                showTime={{ format: 'HH:mm' }}
                format="YYYY-MM-DD"
                placeholder={['Start Date', 'End Date']}
                onChange={this.chooseRangerPicker}
                onOk={this.onOk}
              />
            </Col>
            <Col span={6}>
              <label>Exclude Counsellors</label>
              <Select
                allowClear
                style={{
                  marginRight: 16
                }}
                mode="tags"
                showSearch={true}
                className={common.width100Pr}
                value={this.state.exdCounsellorId}
                placeholder="Select Option"
                optionFilterProp="display"
                filterOption={(input, option) => {
                  return (
                    option.props.children.toLowerCase().indexOf(input.toLowerCase()) >= 0
                  )
                }}
                onChange={exdCounsellorId => {
                  this.setState(
                    {
                      exdCounsellorId: exdCounsellorId
                    },
                    () => {
                      setTimeout(() => {
                        this.table.current.reload()
                      }, 500);
                    }
                  );
                }}>
                {
                  allCounsellor.map((val, idn) => {
                    return (
                      <Option key={idn} value={val._id}>
                        {val.name}
                      </Option>
                    )
                  })
                }
              </Select>
            </Col>
            <Col span={5}>
              <label>Rating</label>
              <Select
                allowClear
                style={{
                  width: 214,
                  paddingRight: 16,
                  paddingLeft: 9
                }}
                placeholder="Select Rating"
                onChange={(ratingId) => {
                  this.setState({
                    ratingId,
                    subRatingId: ''
                  }, () => {
                    setTimeout(() => {
                      this.table.current.reload()
                    }, 500);
                  })
                  this.getAllSubRatings(ratingId)
                }}
              >
                {ratingArr.map((val, idn) => (
                  <Option key={idn} value={val._id}>{val.ratingName}</Option>
                ))}
              </Select>
            </Col>
            <Col span={4}>
              <label>Sub-Rating</label>
              <Select
                allowClear
                style={{
                  width: 214,
                  paddingRight: 16,
                  paddingLeft: 9
                }}
                value={this.state.subRatingId}
                placeholder="Select Sub Rating"
                onChange={(subRatingId) => {
                  this.setState(
                    {
                      subRatingId
                    }, () => {
                      setTimeout(() => {
                        this.table.current.reload()
                      }, 500);
                    }
                  )
                }}
              >
                {subRatingArr.map((val, idn) => (
                  <Option key={idn} value={val._id}>{val.ratingName}</Option>
                ))}
              </Select>
            </Col>
          </div>
        </Card>
        <Card style={{ marginBottom: 10 }}>
          <div className={styles.filterBlock}>
            <div className={styles.myBtnGroup}>
              {/* {
                counsellors && counsellors.length ?
                  <div style={{ float: 'left' }}>
                    <Select
                      allowClear
                      style={{
                        width: 225,
                        marginRight: 16
                      }}
                      showSearch={true}
                      className={common.width100Pr}
                      value={this.state.counsellorId}
                      placeholder="Select Option"
                      optionFilterProp="display"
                      filterOption={(input, option) => {
                        return (
                          option.props.children.toLowerCase().indexOf(input.toLowerCase()) >= 0
                        )
                      }}
                      onChange={counsellorId => {
                        this.setState(
                          {
                            counsellorId: counsellorId && counsellorId.toString()
                          },
                          () => {
                            setTimeout(() => {
                              this.table.current.reload()
                            }, 500);
                          }
                        );
                      }}>
                      {
                        counsellors.map((val, idn) => {
                          return (
                            <Option key={idn} value={val.id}>
                              {val.display}
                            </Option>
                          )
                        })
                      }
                    </Select>
                    <Input
                      allowClear
                      style={{
                        width: 225,
                        marginRight: 16
                      }}
                      className={common.width100Pr}
                      value={this.state.studentSearchId}
                      hidden={rightAuth.checkRights("searchStudent.view") === true ? false : true}
                      placeholder="Enter Student ID"
                      onChange={studentSearchId => {
                        this.setState(
                          {
                            studentSearchId: studentSearchId && studentSearchId.target.value
                          },
                          () => {
                            setTimeout(() => {
                              this.table.current.reload()
                            }, 500);
                          }
                        );
                      }} />
                    {
                      rightAuth.checkRights("ConsellingDeskExcelExport.view") ?
                        <Button
                          className={styles.btn}
                          style={{ marginLeft: 10 }}
                          onClick={() => this.exportExcel()}>
                          Export Excel
                        </Button>
                        : null
                    }
                  </div>
                  : null
              } */}
              <div className="antd-pro-containers-student-inquiry-all-styles-myBtnGroup">
                {
                  rightAuth.checkRights("ConsellingDeskExcelExport.view") ?
                    <Button
                      className={styles.btn}
                      style={{ marginLeft: 10 }}
                      onClick={() => this.exportExcel()}>
                      Export Excel
                    </Button>
                    : null
                }
                <Button
                  className={styles.btn}
                  type="primary"
                  onClick={() => this.showEmail()}>Send E-mail
                </Button>
                <Button
                  type="primary"
                  className={styles.btn}
                  onClick={() => this.showSMS()}>Send SMS
                </Button>
                <Button
                  type="primary"
                  className={styles.btn}
                  onClick={() => this.showWhatsAppSms()}>Whatsapp
                </Button>
                <Button
                  className={styles.btn}
                  onClick={() => this.selectAllUserFxn()}>Select Visible
                </Button>
                <Button
                  className={styles.btn}
                  onClick={() => this.unselectAllUserFxn()}>Unselect Visible
                </Button>
              </div>
            </div>
          </div>
        </Card>
        <Card bordered={true}>
          <TableComp
            id={"allCounsellingDesk"}
            columns={columns}
            ref={this.table}
            showSelector={true}
            apiRequest={this.apiRequest}
            extraProps={{ scroll: { x: 2350 } }}
            pagination={{
              showSizeChanger: true,
              defaultPageSize: 10,
              pageSizeOptions: ["10", "20", "50", "100", "1000"],
            }}
          />
        </Card>

        <Drawer
          title=""
          placement="right"
          closable={true}
          onClose={() => {
            this.setState({
              courseDrawer: false,
            });
          }}
          visible={this.state.courseDrawer}
          width={1200}
        >
          <div>
            <h3 style={{ fontSize: 20, padding: 10 }}>Selected Courses</h3>
            <Table
              bordered={true}
              columns={courseColumns}
              dataSource={this.state.courseList}
              pagination={false}
            />
          </div>
        </Drawer>
      </PageHeaderWrapper>
    );
  }
}

const mapStateToProps = ({ global, router }) => ({
  categories: global.categories,
  search: router.location.search,
});

const mapDispatchToProps = (dispatch) => {
  return {
    dispatch,
  };
};

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(DeadCounsellingDesk);
